import { SVGProps } from 'react';

const CaseSensitive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16m11-7v7M3.304 13h6.392M22 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
    />
  </svg>
);
export default CaseSensitive;
